import * as imagesLoaded from 'imagesloaded/imagesloaded.js';
import * as Isotope from 'isotope-layout/js/isotope';
import * as jQueryBridget from 'jquery-bridget/jquery-bridget';

(function($) {
  jQueryBridget('isotope', Isotope, $);

  /*----------------------------------------------------*/
  /*  products_isotope
  /*----------------------------------------------------*/
  function home_gallery() {
    var $productsInner = $('.ms_products_inner');

    if ($productsInner.length) {
      // Activate isotope in container
      imagesLoaded(document.querySelector('.ms_products_inner'), function() {
        $productsInner.isotope({
          itemSelector: '.ms_p_item',
          layoutMode: 'masonry',
          percentPosition: true,
          columnWidth: 1,
        });
      });
    }
  }
  home_gallery();

  /*----------------------------------------------------*/
  /*  products js
  /*----------------------------------------------------*/
  function products_isotope() {
    var $productsFilterItems = $('.products_filter ul li');
    var $productsInner = $('.ms_products_inner');

    if ($productsFilterItems.length) {
      // Add isotope click function
      $productsFilterItems.on('click', function() {
        $productsFilterItems.removeClass('active');
        var self = $(this);
        self.addClass('active');

        var selector = self.attr('data-filter');
        $productsInner.isotope({
          filter: selector,
          animationOptions: {
            duration: 450,
            easing: 'linear',
            queue: false,
          },
        });
        return false;
      });
    }
  }
  products_isotope();

  /*----------------------------------------------------*/
  /*  Maps js
  /*----------------------------------------------------*/
  function map_filter() {
    var $mapFilterItems = $('.map_filter ul li');
    var $classMaps = $('[class^="map-"');

    if ($mapFilterItems.length) {
      $mapFilterItems.on('click', function() {
        $mapFilterItems.removeClass('active');
        var self = $(this);

        self.addClass('active');
        $classMaps.hide();

        var selector = self.attr('data-map');

        $('#' + selector)
          .parent()
          .fadeToggle();
        var $markers = $('#' + selector).data('markers');
        var map = new window.google.maps.Map(
          document.getElementById(selector),
          {
            scrollwheel: false,
            scaleControl: true,
            streetViewControl: false,
            panControl: true,
            disableDoubleClickZoom: true,
            mapTypeControl: false,
            zoom: 16,
          }
        );

        var bounds = setMarkers(map, $markers);

        if ($markers.length > 1) {
          map.fitBounds(bounds);
        } else {
          map.setCenter($markers[0]);
        }

        window.google.maps.event.trigger(map, 'resize');

        return false;
      });

      $mapFilterItems.first().click();
    }

    function setMarkers(map, locations) {
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < locations.length; i++) {
        var local = locations[i];
        var myLatLng = new window.google.maps.LatLng(local.lat, local.lng);

        new window.google.maps.Marker({
          position: myLatLng,
          map: map,
          animation: window.google.maps.Animation.DROP,
        });

        bounds.extend(myLatLng);
      }
      return bounds;
    }
  }
  map_filter();
})(jQuery);
